/**
 * 语言切换器（U2 §5.2 / D5）
 *  - 顶栏右侧 🌐 入口，菜单切换 zh / en
 *  - 切换经 LocaleProvider 持久化并注入 REST 头 x-locale
 */
import { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import CheckIcon from '@mui/icons-material/Check';
import TranslateIcon from '@mui/icons-material/Translate';
import { useI18n, type Locale } from '../../i18n';

export default function LanguageSwitcher() {
  const { locale, setLocale, t } = useI18n();
  const [anchor, setAnchor] = useState<null | HTMLElement>(null);

  const options: { value: Locale; label: string }[] = [
    { value: 'zh', label: t('lang.zh') },
    { value: 'en', label: t('lang.en') },
  ];

  return (
    <>
      <IconButton
        size="small"
        onClick={(e) => setAnchor(e.currentTarget)}
        aria-label={t('lang.label')}
        sx={{ color: 'text.secondary' }}
      >
        <TranslateIcon fontSize="small" />
      </IconButton>
      <Menu anchorEl={anchor} open={!!anchor} onClose={() => setAnchor(null)}>
        {options.map((o) => (
          <MenuItem
            key={o.value}
            selected={o.value === locale}
            onClick={() => {
              setLocale(o.value);
              setAnchor(null);
            }}
          >
            <ListItemIcon sx={{ minWidth: 28 }}>
              {o.value === locale ? <CheckIcon fontSize="small" /> : null}
            </ListItemIcon>
            <ListItemText>{o.label}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
